export default "__VITE_ASSET__CeuPrvL8__"